import React from "react"

class PasswordRule extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className={this.props.fulfilled ? "password-fulfilled": "password-unfulfilled"}>
                <span className="password-checkmark">
                    {this.props.fulfilled ? "✓" : "✗"}
                </span>
                <span>{this.props.ruleText}</span>
            </div>
        )
    }
}

export default PasswordRule;
